module.exports = __webpack_public_path__ + "static/va-refinance-a237d01f3886ba67c718c170b1f41315.jpg";